export type WeightedOption = {
  weight: number;
};

export const pickWeighted = <T extends WeightedOption>(pool: readonly T[]): T | undefined => {
  if (!pool.length) return undefined;
  const total = pool.reduce((sum, option) => sum + option.weight, 0);
  if (total <= 0) return undefined;
  let random = Math.random() * total;
  for (const option of pool) {
    random -= option.weight;
    if (random <= 0) return option;
  }

  return pool[pool.length - 1];
};
